import { render, staticRenderFns } from "./ListItemDailyFunctionalityWeb.vue?vue&type=template&id=4473c907&"
import script from "./ListItemDailyFunctionalityWeb.vue?vue&type=script&lang=js&"
export * from "./ListItemDailyFunctionalityWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
